export const safeDivide = (numerator, denominator, options = {}) => {
    const {
        multiplyBy = 1,     // e.g. 100 for %
        decimals = null,    // e.g. 2 for rounding
        defaultValue = null // fallback (null / 0 / "N/A")
    } = options;

    if (
        numerator === null || numerator === undefined ||
        denominator === null || denominator === undefined ||
        denominator === 0
    ) {
        return defaultValue;
    }

    const result = (numerator * multiplyBy) / denominator;

    if (!Number.isFinite(result)) {
        return defaultValue;
    }

    return decimals !== null
        ? Number(result.toFixed(decimals)) // keep numeric
        : result;
};